import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LocalizeRouterService } from 'localize-router';
import { ApiService } from '../../_services/api.service';
import { AuthService } from '../../_services/auth.sevice';
import { StorageService } from '../../_services/storage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styles: [`
    .cred {
      color:#C1092B
    }
    .not-link {
      cursor: auto;
      text-decoration: none;
    }
  `]
})
export class LoginComponent implements OnInit {

  constructor(
    private translate: TranslateService,
    private auth: AuthService,
    private route: ActivatedRoute,
    private api: ApiService,
    private localize: LocalizeRouterService
  ) { }

  jsonIn: any = {};

  errorCredenziali;
  recuperoShow;
  recuperoConferma = false;
  showResetPasswordModal = false;
  emailResetPassword;
  erroreResetPassword;
  resetPasswordSuccess;

  returnUrl;

  @Output() loginSuccess = new EventEmitter<void>();
  @Input() inputLoginTest = 'default';

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.returnUrl) {
        this.returnUrl = params.returnUrl;
      }
    });
  }

  login() {
    this.auth.login(this.jsonIn).subscribe((res: any) => {
      if (res.esito === 'OK' && res.result) {
        this.loginSuccess.emit();
        if (this.returnUrl) {
          window.location.href = this.returnUrl;
        }
      } else {
        this.errorCredenziali = true;
      }
    });
  }

  resetPassword() {
    this.api.resetPassword({languange: this.localize.parser.currentLang.toUpperCase(), email: this.emailResetPassword}).subscribe((res: any) => {
      if (res.esito === 'OK') {
        this.resetPasswordSuccess = true;
      } else {
        this.erroreResetPassword = true;
      }
    });
  }
}
